export default "__VITE_ASSET__CRZlk4Hx__"